import { FilterList } from '@mui/icons-material';
import { Fab, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, FormControlLabel, Checkbox, Stack, Chip } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import ProcessoStore from '../../store/ProcessoStore';
import ControleGabineteStore from '../../store/ControleGabineteStore';
import { AppStore } from '../../store/AppStore';
import IconeLimpar from '@/img/icones/IconeLimpar';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LayoutStore from '@/store/LayoutStore';

interface IPropsBotaoFiltrarOJC { }

interface IStateBotaoFiltrarOJC {
    aberto: boolean;
    selecionados: string[];
    hoverVisibilidade: boolean;
}


class BotaoFiltrarOJC extends React.Component {
    state = {
        aberto: false,
        selecionados: [] as string[],
        hoverVisibilidade: false
    };

    filtroOjcDesabilitado = () => {
        const carregamentoControleNaoConcluido =
            ControleGabineteStore.carregandoControles ||
            !ControleGabineteStore.controlesCarregados;
        const carregamentoProcessosNaoConcluido =
            AppStore.isCarregandoTodosProcessos ||
            ProcessoStore.carregandoProcessosNoEscaninho ||
            !ProcessoStore.carregouProcessosNoEscaninho;

        return carregamentoControleNaoConcluido || carregamentoProcessosNaoConcluido;
    };

    abrirDialog = () => {
        if (this.filtroOjcDesabilitado()) {
            return;
        }

        const valorAtual = ControleGabineteStore.filtroOJC;

        this.setState({
            aberto: true,
            selecionados: valorAtual
                ? Array.isArray(valorAtual)
                    ? valorAtual
                    : [valorAtual]
                : [],
        });
    };

    fecharDialog = () => {
        this.setState({ aberto: false });
    };

    toggleSelecionado = (sigla: string) => {
        this.setState((prevState: any) => {
            const jaSelecionado = prevState.selecionados.includes(sigla);
            const selecionados = jaSelecionado
                ? prevState.selecionados.filter((s: string) => s !== sigla)
                : [...prevState.selecionados, sigla];
            return { selecionados };
        });
    };

    selecionarTodos = (listaOjcUnicos: string[]) => {
        const { selecionados } = this.state;
        const todosSelecionados = listaOjcUnicos.length === selecionados.length;
        this.setState({
            selecionados: todosSelecionados ? [] : [...listaOjcUnicos],
        });
    };

    aplicarFiltro = () => {
        const { selecionados } = this.state;
        let valor: string | string[] | null = null;

        if (selecionados.length === 1) valor = selecionados[0];
        else if (selecionados.length > 1) valor = selecionados;

        ControleGabineteStore.setFiltroOJC(valor);
        this.fecharDialog();
    };

    limparFiltro = () => {
        ControleGabineteStore.limparFiltroOJC();
        this.setState({ selecionados: [] });
    };

    removerChip = (sigla: string) => {
        const valorAtual = ControleGabineteStore.filtroOJC;

        if (!valorAtual) return;

        let novoValor: string | string[] | null = null;

        if (Array.isArray(valorAtual)) {
            const atualizado = valorAtual.filter((s) => s !== sigla);
            if (atualizado.length === 1) novoValor = atualizado[0];
            else if (atualizado.length > 1) novoValor = atualizado;
            else novoValor = null;
        } else {
            novoValor = null;
        }

        if (novoValor === null) {
            ControleGabineteStore.limparFiltroOJC();
        } else {
            ControleGabineteStore.setFiltroOJC(novoValor);
        }
    };

    render() {
        const filtroOjcDesabilitado = this.filtroOjcDesabilitado();
        // No tema escuro o anel claro do hover destoa; usa um cinza escuro.
        const outlineHover = LayoutStore.isTemaDark ? '#4a4a4a' : '#d7d7d8';
        const listaOjcUnicos = ProcessoStore.ojcsDisponiveis;
        const { aberto, selecionados } = this.state;
        const rawFiltro = ControleGabineteStore.filtroOJC;
        const filtrosAtuais =
            rawFiltro == null ||
                rawFiltro === '' ||
                (Array.isArray(rawFiltro) && rawFiltro.length === 0)
                ? []
                : Array.isArray(rawFiltro)
                    ? rawFiltro
                    : [rawFiltro];
        const todosSelecionados =
            listaOjcUnicos.length > 0 &&
            listaOjcUnicos.length === selecionados.length;

        return (
            <>
                <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    flexWrap="wrap"
                    sx={{
                        gap: '10px 0px',
                    }}
                >
                    <Tooltip title="Filtrar por OJC">
                        <Fab
                            disabled={filtroOjcDesabilitado}
                            sx={{
                                backgroundColor: '#01579b',
                                boxShadow: 'none',
                                outline: 'none',
                                transition: 'outline-offset 0.2s ease-in-out',
                                '&:hover': {
                                    backgroundColor: '#01579b',
                                    outline: `8px solid ${outlineHover}`,
                                    outlineOffset: '2px',
                                },
                            }}
                            size="small"
                            onClick={this.abrirDialog}
                        >
                            <FilterList sx={{ color: 'white' }} />
                        </Fab>
                    </Tooltip>

                    {filtrosAtuais.length > 0 && (
                        <Tooltip title="Alternar visibilidade das caixas sem processos">
                            <Fab
                                sx={{
                                    backgroundColor: ControleGabineteStore.visibilidadeAtiva
                                        ? '#269b47ff'
                                        : '#a9a9a9ff',
                                    boxShadow: 'none',
                                    outline: 'none',
                                    transition: 'outline-offset 0.2s ease-in-out',

                                    '&:hover': {
                                        backgroundColor: ControleGabineteStore.visibilidadeAtiva
                                            ? '#269b47ff'
                                            : '#a9a9a9ff',
                                        outline: `8px solid ${outlineHover}`,
                                        outlineOffset: '2px',
                                    },
                                }}
                                size="small"
                                onClick={() =>
                                    ControleGabineteStore.setVisibilidadeAtiva(
                                        !ControleGabineteStore.visibilidadeAtiva
                                    )
                                }
                            >
                                {ControleGabineteStore.visibilidadeAtiva ? (
                                    <Visibility sx={{ color: 'white' }} />
                                ) : (
                                    <VisibilityOff sx={{ color: 'white' }} />
                                )}
                            </Fab>
                        </Tooltip>
                    )}

                    {filtrosAtuais.length > 0 && (
                        <Tooltip title="Limpar filtro">
                            <Fab
                                sx={{
                                    backgroundColor: '#c62828',
                                    boxShadow: 'none',
                                    outline: 'none',
                                    transition: 'outline-offset 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: '#b71c1c',
                                        outline: `8px solid ${outlineHover}`,
                                        outlineOffset: '2px',
                                    },
                                }}
                                size="small"
                                onClick={this.limparFiltro}
                            >
                                <IconeLimpar fill="white" />
                            </Fab>
                        </Tooltip>
                    )}

                    {filtrosAtuais.map((sigla) => (
                        <Chip
                            key={sigla}
                            label={sigla}
                            onDelete={() => this.removerChip(sigla)}
                            color="primary"
                            sx={{
                                fontSize: '0.85rem',
                                height: 28,
                            }}
                        />
                    ))}
                </Stack>

                <Dialog
                    open={aberto}
                    onClose={this.fecharDialog}
                    maxWidth="xs"
                    fullWidth
                    sx={{
                        '& .MuiFormControlLabel-label': { fontSize: '15px' },
                        '& .MuiButton-root': { fontSize: '15px' },
                    }}
                >
                    <DialogTitle>Selecionar OJC</DialogTitle>
                    <DialogContent dividers>
                        <FormGroup>
                            {listaOjcUnicos.map((sigla) => (
                                <FormControlLabel
                                    key={sigla}
                                    control={
                                        <Checkbox
                                            checked={selecionados.includes(sigla)}
                                            onChange={() =>
                                                this.toggleSelecionado(sigla)
                                            }
                                        />
                                    }
                                    label={sigla}
                                />
                            ))}
                        </FormGroup>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            justifyContent: 'space-between',
                        }}
                    >
                        <Button
                            onClick={() =>
                                this.selecionarTodos(listaOjcUnicos)
                            }
                            color={todosSelecionados ? 'secondary' : 'success'}
                            variant="outlined"
                        >
                            {todosSelecionados
                                ? 'Desmarcar todos'
                                : 'Selecionar todos'}
                        </Button>
                        <Stack direction="row" spacing={1}>
                            <Button
                                onClick={this.fecharDialog}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={this.aplicarFiltro}
                                variant="contained"
                            >
                                Aplicar
                            </Button>
                        </Stack>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default observer(BotaoFiltrarOJC);
